import type { FC, ReactNode } from 'react';
import { Children, cloneElement, isValidElement } from 'react';

/**
 * A component that adds the Braze Tag Manager ID to its children.
 *
 * @param {string} id
 * @param {ReactNode} children
 * @returns {ReactNode}
 */
type TagManagerIdProps = {
  id: string;
  children: ReactNode;
};

export const TagManagerId: FC<TagManagerIdProps> = ({ id, children }) => {
  try {
    const child = Children.only(children);

    if (isValidElement<Record<string, unknown>>(child)) {
      return cloneElement(child, {
        'data-tm-id': id,
      });
    }
  } catch (e) {
    console.warn(
      'TagManagerId can only accept one React element as children',
      e
    );
    return children;
  }
  return children;
};
